<script setup lang="ts">
withDefaults(defineProps<{ to?: string; pressed?: boolean; size?: 'sm' | 'md'; disabled?: boolean }>(), { pressed: false, size: 'md', disabled: false })
const emit = defineEmits<{ 'update:pressed': [value: boolean] }>()
</script>

<template><NuxtLink v-if="to" :to="to" class="chip" :class="{ sm: size === 'sm' }"><slot /></NuxtLink><button v-else type="button" class="chip" :class="{ sm: size === 'sm' }" :aria-pressed="pressed" :disabled="disabled" @click="emit('update:pressed', !pressed)"><slot /></button></template>
